export default {
	section_banner: {
		title: {
			one: 'Free Your',
		},
		main_title: {
			one: 'Transfer Fee',
		},
		paragraph: {
			one: 'Enjoy seamless money transfers with no fees when sending between JPWorldPay accounts. It is fast, secure, and cost-effective. Stay connected and send funds effortlessly anytime, anywhere.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	question_sec: {
		label: 'When Depositing To An External Wallet',
		title: {
			one: 'Only The',
			two: 'Network Fee',
			three: 'Is Charged',
		},
		paragraph: {
			one: 'When making a deposit, JPWorldPay does not request any payment of fees. This user-friendly approach ensures that your full amount is credited without deductions, making the deposit process straightforward, transparent, and cost-effective.',
		},
		cta_button: {
			one: 'Get Started',
		},
	},

	commi_platfrom: {
		label: 'Choose The Right Platform',
		title: {
			one: 'Movement Within Our',
			two: 'Platform Is Free',
		},
		paragraph: {
			one: 'External withdrawals may incur a network fee, but all purchases made with JPWorldPay remain fee-free. This ensures clear, upfront costs while you enjoy secure and seamless transactions every time.',
			two: 'Enjoy a seamless payment experience without hidden charges. JPWorldPay is designed to keep your everyday spending simple and cost-effective.',
			three:
				'With JPWorldPay, managing your finances becomes more efficient and user-friendly. Whether you are shopping online, sending money, or withdrawing to an external wallet, you are always in control.',
			four: 'Enjoy reliable service, low costs, and peace of mind every step of the way. Our user-friendly interface ensures quick navigation and smooth transactions.',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
